module.exports = __webpack_public_path__ + "static/media/Foongus_gaussian2.f28a8b07.png";